import React from 'react';
import './usersList.css';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import { getUsersThunk } from "../../redux/thunks/getUsersThunk";
import Pagination from "../Pagination/Pagination";
import { transferUserDataFormAction } from "../../redux/rootReducer";
import { TRANSFER_USER_DATA_FORM_INITIAL } from "../../redux/initialStateConstant";
import UserTransferForm from "../UserTransferForm/UserTransferForm";
import { getUserInfoSagaAction } from "../../redux/sagaActions";
import Tippy from "@tippyjs/react";

const UsersList = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const usersList = useSelector(state => state.usersList);
    const filterUsers = useSelector(state => state.filterUsers);

    // Функция смены страницы
    const changePage = page => {
        dispatch(getUsersThunk({
            page,
            without_subscriptions: filterUsers.without_subscriptions,
            expire_to: filterUsers.expire_to,
            workouts_less_than: filterUsers.workouts_less_than,
            registration_not_later: filterUsers.registration_not_later,
            not_been_x_months: filterUsers.not_been_x_months,
            last_workout_from: filterUsers.last_workout_from,
            last_workout_to: filterUsers.last_workout_to,
            birthday_from: filterUsers.birthday_from,
            birthday_to: filterUsers.birthday_to,
            admin: filterUsers.admin,
            coach: filterUsers.coach,
            workouts_count: filterUsers.workouts_count,
            debt: filterUsers.debt,
            without_workouts: filterUsers.without_workouts
        }));
    };

    return (
        <>
            <UserTransferForm/>
            <div className="users__list">
                <div className="user__transfer" onClick={ () => dispatch(transferUserDataFormAction({
                    ...TRANSFER_USER_DATA_FORM_INITIAL,
                    open: true
                })) }>Перенос данных</div>
                <div className="table__header">
                    <div className="table__caption">Список посетителей</div>
                </div>
                <div className="table">
                    <div className="table__row table__row--header users__table">
                        <div className="table__cell table__cell--left">Имя</div>
                        <div className="table__cell">Телефон</div>
                        <div className="table__cell">Дата регистрации</div>
                        <div className="table__cell">Последняя тренировка</div>
                        <div className="table__cell">Email</div>
                        <div className="table__cell">Долг</div>
                    </div>
                    {
                        usersList.map(elem => {
                            return (
                                <div className="table__row table__row--hover users__table" key={ elem.id }
                                     onClick={ () => {
                                         if (!elem.id) return;

                                         // Добавляем id пользователя в адрес
                                         history.push('/fitness/users/' + elem.id);
                                         dispatch(getUserInfoSagaAction({ id: elem.id }));
                                     } }
                                >
                                    <div className="table__cell table__cell--left">
                                        { elem.name }
                                        {
                                            elem.name &&
                                            <Tippy content={ 'Открыть в новой вкладке' }>
                                                <div className="user__tab"
                                                     onClick={ event => {
                                                         event.preventDefault();
                                                         event.stopPropagation();

                                                         window.open('/fitness/users/' + elem.id, '_blank', 'noopener,noreferrer');
                                                     } }
                                                />
                                            </Tippy>
                                        }
                                    </div>
                                    <div className="table__cell">{ elem.phone }</div>
                                    <div className="table__cell">{ elem.date_registration }</div>
                                    <div className="table__cell">{ elem.last_workout }</div>
                                    <div className="table__cell">{ elem.email }</div>
                                    <div className="table__cell">{ elem.debt_sum }</div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
            <Pagination handler={ changePage }/>
        </>
    );
};

export default UsersList;